"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNullOptional = exports.getNull = exports.getArrayOptionalNullable = exports.getArrayNullable = exports.getArrayOptional = exports.getArray = exports.getObjectOptionalNullable = exports.getObjectNullable = exports.getObjectOptional = exports.getObject = exports.getBooleanOptionalNullable = exports.getBooleanNullable = exports.getBooleanOptional = exports.getBoolean = exports.getIntegerOptionalNullable = exports.getIntegerNullable = exports.getIntegerOptional = exports.getInteger = exports.getNumberOptionalNullable = exports.getNumberNullable = exports.getNumberOptional = exports.getNumber = exports.getStringOptionalNullable = exports.getStringNullable = exports.getStringOptional = exports.getString = void 0;
const validationError_1 = __importDefault(require("./validationError"));
function typeError(expectedType, value, valueName) {
    return validationError_1.default(`Expected ${valueName || "value"} to be of type ${expectedType}. Got ${value}.`);
}
/**
 * Throws if `value` isn't a string.
 */
function getString(value, valueName) {
    if (typeof value !== "string") {
        throw typeError("string", value, valueName);
    }
    return value;
}
exports.getString = getString;
/**
 * Throws if `value` isn't a string or undefined.
 */
function getStringOptional(value, valueName) {
    return value === undefined ? value : getString(value, valueName);
}
exports.getStringOptional = getStringOptional;
/**
 * Throws if `value` isn't a string or null.
 */
function getStringNullable(value, valueName) {
    return value === null ? value : getString(value, valueName);
}
exports.getStringNullable = getStringNullable;
/**
 * Throws if `value` isn't a string or null.
 */
function getStringOptionalNullable(value, valueName) {
    return value === null || value === undefined
        ? value
        : getString(value, valueName);
}
exports.getStringOptionalNullable = getStringOptionalNullable;
/**
 * Throws if `value` isn't a number.
 */
function getNumber(value, valueName) {
    if (typeof value !== "number" || Number.isNaN(value)) {
        throw typeError("number", value, valueName);
    }
    return value;
}
exports.getNumber = getNumber;
/**
 * Throws if `value` isn't a number or undefined.
 */
function getNumberOptional(value, valueName) {
    return value === undefined ? value : getNumber(value, valueName);
}
exports.getNumberOptional = getNumberOptional;
/**
 * Throws if `value` isn't a number or null.
 */
function getNumberNullable(value, valueName) {
    return value === null ? value : getNumber(value, valueName);
}
exports.getNumberNullable = getNumberNullable;
/**
 * Throws if `value` isn't a number or null.
 */
function getNumberOptionalNullable(value, valueName) {
    return value === null || value === undefined
        ? value
        : getNumber(value, valueName);
}
exports.getNumberOptionalNullable = getNumberOptionalNullable;
/**
 * Throws if `value` isn't a number or if `value` is a decimal value.
 */
function getInteger(value, valueName) {
    if (typeof value !== "number" || Number.isNaN(value) || value % 1 !== 0) {
        throw typeError("number", value, valueName);
    }
    return value;
}
exports.getInteger = getInteger;
/**
 * Throws if `value` isn't a number or undefined or if `value` is a decimal value.
 */
function getIntegerOptional(value, valueName) {
    return value === undefined ? value : getInteger(value, valueName);
}
exports.getIntegerOptional = getIntegerOptional;
/**
 * Throws if `value` isn't a number or null or if `value` is a decimal value.
 */
function getIntegerNullable(value, valueName) {
    return value === null ? value : getInteger(value, valueName);
}
exports.getIntegerNullable = getIntegerNullable;
/**
 * Throws if `value` isn't a number or null or if `value` is a decimal value.
 */
function getIntegerOptionalNullable(value, valueName) {
    return value === null || value === undefined
        ? value
        : getInteger(value, valueName);
}
exports.getIntegerOptionalNullable = getIntegerOptionalNullable;
/**
 * Throws if `value` isn't a boolean.
 */
function getBoolean(value, valueName) {
    if (typeof value !== "boolean") {
        throw typeError("boolean", value, valueName);
    }
    return value;
}
exports.getBoolean = getBoolean;
/**
 * Throws if `value` isn't a boolean or undefined.
 */
function getBooleanOptional(value, valueName) {
    return value === undefined ? value : getBoolean(value, valueName);
}
exports.getBooleanOptional = getBooleanOptional;
/**
 * Throws if `value` isn't a boolean or null.
 */
function getBooleanNullable(value, valueName) {
    return value === null ? value : getBoolean(value, valueName);
}
exports.getBooleanNullable = getBooleanNullable;
/**
 * Throws if `value` isn't a boolean or null.
 */
function getBooleanOptionalNullable(value, valueName) {
    return value === null || value === undefined
        ? value
        : getBoolean(value, valueName);
}
exports.getBooleanOptionalNullable = getBooleanOptionalNullable;
/**
 * Throws if `value` isn't an object.
 */
function getObject(value, valueName) {
    if (value === null || typeof value !== "object" || Array.isArray(value)) {
        throw typeError("object", value, valueName);
    }
    return value;
}
exports.getObject = getObject;
/**
 * Throws if `value` isn't an object or undefined.
 */
function getObjectOptional(value, valueName) {
    return value === undefined ? value : getObject(value, valueName);
}
exports.getObjectOptional = getObjectOptional;
/**
 * Throws if `value` isn't an object or null.
 */
function getObjectNullable(value, valueName) {
    return value === null ? value : getObject(value, valueName);
}
exports.getObjectNullable = getObjectNullable;
/**
 * Throws if `value` isn't an object or null.
 */
function getObjectOptionalNullable(value, valueName) {
    return value === null || value === undefined
        ? value
        : getObject(value, valueName);
}
exports.getObjectOptionalNullable = getObjectOptionalNullable;
/**
 * Throws if `value` isn't an array.
 */
function getArray(value, valueName) {
    if (!Array.isArray(value)) {
        throw typeError("array", value, valueName);
    }
    return value;
}
exports.getArray = getArray;
/**
 * Throws if `value` isn't an array or undefined.
 */
function getArrayOptional(value, valueName) {
    return value === undefined ? value : getArray(value, valueName);
}
exports.getArrayOptional = getArrayOptional;
/**
 * Throws if `value` isn't an array or null.
 */
function getArrayNullable(value, valueName) {
    return value === null ? value : getArray(value, valueName);
}
exports.getArrayNullable = getArrayNullable;
/**
 * Throws if `value` isn't an array or null.
 */
function getArrayOptionalNullable(value, valueName) {
    return value === null || value === undefined
        ? value
        : getArray(value, valueName);
}
exports.getArrayOptionalNullable = getArrayOptionalNullable;
/**
 * Throws if `value` isn't null.
 */
function getNull(value, valueName) {
    if (value !== null) {
        throw typeError("null", value, valueName);
    }
    return value;
}
exports.getNull = getNull;
/**
 * Throws if `value` isn't a string or undefined.
 */
function getNullOptional(value, valueName) {
    return value === undefined ? value : getNull(value, valueName);
}
exports.getNullOptional = getNullOptional;
/**
 * Present a clean chainable API.
 *
 * Example:
 *
 * ```ts
 * const bar = from.number(10 as unknown); // number
 * const foo = from.string.nullable.optional('a' as unknown); // string | null | undefined
 * ```
 */
exports.default = {
    string: Object.assign(getString, {
        optional: Object.assign(getStringOptional, {
            nullable: getStringOptionalNullable,
        }),
        nullable: Object.assign(getStringNullable, {
            optional: getStringOptionalNullable,
        }),
    }),
    integer: Object.assign(getInteger, {
        optional: Object.assign(getIntegerOptional, {
            nullable: getIntegerOptionalNullable,
        }),
        nullable: Object.assign(getIntegerNullable, {
            optional: getIntegerOptionalNullable,
        }),
    }),
    number: Object.assign(getNumber, {
        optional: Object.assign(getNumberOptional, {
            nullable: getNumberOptionalNullable,
        }),
        nullable: Object.assign(getNumberNullable, {
            optional: getNumberOptionalNullable,
        }),
    }),
    boolean: Object.assign(getBoolean, {
        optional: Object.assign(getBooleanOptional, {
            nullable: getBooleanOptionalNullable,
        }),
        nullable: Object.assign(getBooleanNullable, {
            optional: getBooleanOptionalNullable,
        }),
    }),
    object: Object.assign(getObject, {
        optional: Object.assign(getObjectOptional, {
            nullable: getObjectOptionalNullable,
        }),
        nullable: Object.assign(getObjectNullable, {
            optional: getObjectOptionalNullable,
        }),
    }),
    array: Object.assign(getArray, {
        optional: Object.assign(getArrayOptional, {
            nullable: getArrayOptionalNullable,
        }),
        nullable: Object.assign(getArrayNullable, {
            optional: getArrayOptionalNullable,
        }),
    }),
    null: Object.assign(getNull, {
        optional: getNullOptional,
    }),
};
//# sourceMappingURL=data:application/json;base64,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